/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { alwaysReducer, falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { Sitemap } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  DONE_LOADING_SITEMAP_COUNTS,
  DONE_LOADING_SITEMAP_URLS,
  RECEIVE_SITEMAP_COUNTS,
  RECEIVE_SITEMAP_URLS,
  START_LOADING_SITEMAP_COUNTS,
  START_LOADING_SITEMAP_URLS,
} from './constants'
import type { ActionTypes } from './types'

export const sitemapReducer = combineReducers<Sitemap, ActionTypes>({
  counts: handleAction<Sitemap['counts'], ActionTypes, typeof RECEIVE_SITEMAP_COUNTS>(
    RECEIVE_SITEMAP_COUNTS,
    payloadReducer,
    null
  ),
  loadingCounts: handleActions<boolean, ActionTypes>(
    {
      [START_LOADING_SITEMAP_COUNTS]: trueReducer,
      [DONE_LOADING_SITEMAP_COUNTS]: falseReducer,
    },
    false
  ),
  loadingUrls: handleActions<Sitemap['loadingUrls'], ActionTypes>(
    {
      [START_LOADING_SITEMAP_URLS]: payloadReducer,
      [DONE_LOADING_SITEMAP_URLS]: (state, { payload }) =>
        state?.limit === payload.limit &&
        state?.offset === payload.offset &&
        state?.type === payload.type
          ? null
          : state,
    },
    null
  ),
  urls: handleActions<Sitemap['urls'], ActionTypes>(
    {
      [RECEIVE_SITEMAP_URLS]: payloadReducer,
      [START_LOADING_SITEMAP_URLS]: alwaysReducer({
        limit: null,
        offset: null,
        type: null,
        urls: [],
      }),
    },
    { limit: null, offset: null, type: null, urls: [] }
  ),
})
